<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Police Verification") }}</h3>
    </v-btn>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" md="9" lg="8">
        <v-row>
          <v-col cols="12" md="12" lg="6">
            <v-checkbox
              v-model="driver.driverDetail.policeVerify"
              :label="$i18n.t('Police Verified')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="12" lg="4">
            <z-date-picker
              v-if="driver.driverDetail.policeVerify"
              :label="$i18n.t('Date')"
              v-model="driver.driverDetail.policeVerifyDate"
            ></z-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" lg="8">
            <v-file-input
              v-if="driver.driverDetail.policeVerify"
              chips
              :label="$i18n.t('Attachment')"
              @change="handlePoliceVerifyFileUpload()"
              v-model="policeVerifyFile"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <br />
            <v-btn
              v-if="policeVerifyFile"
              color="purple lighten-2"
              small
              v-on:click="uploadPoliceVerification"
            >
              <h3>{{ $i18n.t("Upload") }}</h3>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" lg="4" v-if="driver.driverDetail.policeVerifyPic.url">
        <v-fade-transition mode="out-in">
          <v-card style="margin: 0">
            <a :href="driver.driverDetail.policeVerifyPic.url">
              <v-img
                :src="driver.driverDetail.policeVerifyPic.url"
                aspect-ratio="2"
                class="grey darken-4"
              ></v-img>
            </a>
            <v-row class="px-2">
              <v-col cols="12" md="12" lg="12">
                {{ driver.driverDetail.policeVerifyPic.by }}
                {{
                driver.driverDetail.policeVerifyPic.time
                | moment("HH:mm DD MMM YYYY")
                }}
              </v-col>
            </v-row>
          </v-card>
        </v-fade-transition>
      </v-col>
      <v-col cols="12" md="1" lg="1"></v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PoliceVerify",
  props: {
    value: {
      default: null,
    },
  },
})
export default class PoliceVerify extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
    if (!this.driver.driverDetail.policeVerifyPic)
      this.driver.driverDetail.policeVerifyPic = {};
  }

  // Police Verification Upload Start
  policeVerifyFile = null;
  handlePoliceVerifyFileUpload(files) {
    if (files) {
      this.policeVerifyFile = files[0];
    }
  }

  async uploadPoliceVerification() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.id) {
        formData.set("name", "Police Verification");
        formData.set("policeVerify", this.driver.driverDetail.policeVerify);
        formData.set("date", this.driver.driverDetail.policeVerifyDate);
      }
      if (this.isSet(this.policeVerifyFile)) {
        formData.append("file", this.policeVerifyFile);
      }
      const url = "/api/driver/" + this.driver._id + "/policePicture/save";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
  // Police Verification Upload Start

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>